import { hasActiveModuleGrant } from '@realadvisor/constants';

import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import {
  MODULES_BROKERAGE,
  MODULES_CMA_REPORTS,
  MODULES_VISIBILITY,
} from '@shared/constants/module';

export const useDashboardModules = () => {
  const { me: currentUser } = useAppData();
  return {
    isBrokerageEnabled: hasActiveModuleGrant(
      currentUser?.module_grants,
      MODULES_BROKERAGE,
    ),
    isCMAEnabled: hasActiveModuleGrant(
      currentUser?.module_grants,
      MODULES_CMA_REPORTS,
    ),
    isVisibilityEnabled: hasActiveModuleGrant(
      currentUser?.module_grants,
      MODULES_VISIBILITY,
    ),
  };
};
